import { ErrorMessage, Field, Form, configure, defineRule } from 'vee-validate';
import { email, required } from '@vee-validate/rules';
defineRule('email', email);
defineRule('required', required);
configure({
    generateMessage: context => {
        const label = context.field || 'This field';
        if (context.rule?.name === 'required') {
            return `${label} is required`;
        }
        if (context.rule?.name === 'email') {
            return `${label} must be a valid email`;
        }
        return `${label} is invalid`;
    }
});
export function configureValidation(app) {
    app.component('VeeForm', Form);
    app.component('VeeField', Field);
    app.component('ErrorMessage', ErrorMessage);
}
